
<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="false"
></app-st-banner>
<br><br><br><br><br>
<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
      <!--<app-st-profile-picture></app-st-profile-picture>-->
    </div>
    <div class="col-8">
      <app-st-header-title [inputVal]="'Forgot Username'"></app-st-header-title>
      <br>
      <div class="container st-form">
        <div *ngIf="showMessages" class="container st-form text-danger" #goUp>
          <app-st-span><b>Please validate the following: </b></app-st-span>
          <div *ngFor="let errorMsg of messages" class="alert alert-danger" role="alert">
            <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
          </div>
          <br>
        </div>
        <div>
          <!--<app-st-input-text [idVal]="'email-text-id'" [label]="'Email'"></app-st-input-text>-->
          <app-st-input-text-phone [idVal]="'phone-number-text-id'"
                                   [label]="'*Phone Number: (Format: 1234567890)'" [inputVal]="inputPhoneNumber" [requiredVal]="true" [maxLength]="20"
          ></app-st-input-text-phone>
          <br>
          <app-st-input-text [idVal]="'last-name-text-id'"
                             [label]="'*Last Name'" [inputVal]="inputLastName"
                             [placeHolderVal]="'Last Name'"
                             [requiredVal]="true"
                             [maxLength]="40"
          ></app-st-input-text>

          <br>
          <span class="webtext-black"><b>Your username is:</b> <ul>{{this.recoveredUsername}}</ul> </span>
        </div>
        <br>
        <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
          <app-st-button [idVal]="'submit-button-id'" [label]="'Submit'" [primary]="true"
                         (click)="this.onSubmit()"></app-st-button>
          <app-st-button-cancel [idVal]="'cancel-button-id'" [label]="'Cancel'" [primary]="false"
                         (click)="this.onCancel()"></app-st-button-cancel>
        </div>
        <br>
      </div>

    </div>
  </div>
</div>
